import "../../../css/GlobalStyles.css";
import { PeoplePanel } from "../../../components/HomePage/PeoplePanel";
import { useLocation } from "react-router-dom";
import { ImportantAnnouncementModal } from "../../../components/DisplayModal/ImportantAnnouncementModal";
import CreatorModePanelWrapper from "../../../components/CreatorDashboard/CreatorModePanelWrapper";

const HomePanel = () => {
  // Set when desktop onboarding skips straight here from the free-plan button
  const { justFinishedOnboarding } = useLocation().state ?? {};

  return (
    <CreatorModePanelWrapper
      title=""
      headerRight={null}
      headerContainerStyles={{ display: "none" }}
    >
      <div className="CreatorPanelContainer" style={{ padding: "24px 30px" }}>
        <PeoplePanel justFinishedOnboarding={justFinishedOnboarding} />
      </div>
      <ImportantAnnouncementModal />
    </CreatorModePanelWrapper>
  );
};

export default HomePanel;
